import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "./ContactUs.css";

const ContactUs = () => {
  const location = useLocation();
  const formRef = useRef(null);

  const [isSending, setIsSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const sendEmail = async (e) => {
    e.preventDefault();

    setIsSending(true);
    setStatusMessage("");
    setIsSuccess(false);

    try {
      await emailjs.sendForm(
        "service_b60llyp",
        "template_hybgwhs",
        formRef.current,
        {
          publicKey: "71xLEc94BZp8guYbj",
        }
      );

      setIsSuccess(true);
      setStatusMessage("✅ Message sent successfully!");
      formRef.current.reset();
    } catch (error) {
      setIsSuccess(false);
      setStatusMessage("❌ Failed to send message. Please try again.");
      console.error("EmailJS Error:", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="contact-us-page">
      <div className="container">
        <h1>Contact Us</h1>

        {/* Intro */}
        <section className="contact-intro">
          <img
            src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=400&fit=crop"
            alt="Office"
            className="intro-image"
          />
          <p>
            Get in touch with our legal experts for professional consultation
            and assistance. We are here to help you with all your legal needs.
          </p>
        </section>

        {/* Contact Info */}
        <section className="contact-info">
          <div className="contact-details">
            <div className="contact-item">
              <h3>Office Address</h3>
              <p>
                Flat No.103, Dikshith Residency, Moosarambagh, Malakpet,
                Hyderabad-500036, Telangana, India
              </p>
            </div>

            <div className="contact-item">
              <h3>Email</h3>
              <p>yadishwarn.advocate@gmail.com</p>
            </div>

            <div className="contact-item">
              <h3>Phone</h3>
              <p>(+91) 93986 04124</p>
            </div>

            <div className="contact-item">
              <h3>Office Hours</h3>
              <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p>Saturday: 10:00 AM - 2:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </section>

        {/* Form */}
        <section className="contact-form-section" id="form">
          <h2>Send Us a Message</h2>

          <form ref={formRef} className="contact-form" onSubmit={sendEmail}>
            <div className="form-row">
              <input type="text" name="firstName" placeholder="First Name" required />
              <input type="text" name="lastName" placeholder="Last Name" required />
            </div>

            <div className="form-row">
              <input type="email" name="email" placeholder="Email" required />
              <input type="tel" name="phone" placeholder="Phone" />
            </div>

            <input type="text" name="subject" placeholder="Subject" required />

            <select name="legalArea">
              <option value="">Select Legal Area</option>
              <option value="civil">Civil Law</option>
              <option value="criminal">Criminal Law</option>
              <option value="corporate">Corporate Law</option>
              <option value="family">Family Law</option>
              <option value="property">Property Law</option>
              <option value="labour">Labour Law</option>
            </select>

            <textarea name="message" rows="5" placeholder="Your Message" required />

            <div className="checkbox-group">
              <input type="checkbox" required />
              <label>I agree to terms *</label>
            </div>

            <button type="submit" disabled={isSending}>
              {isSending ? "Sending..." : "Send Message"}
            </button>

            {statusMessage && (
              <p style={{ color: isSuccess ? "green" : "red" }}>
                {statusMessage}
              </p>
            )}
          </form>
        </section>

    

        <section className="location-map">
          <h2>Our Location</h2>

          <iframe
            src="https://www.google.com/maps?q=Flat No.103, Dikshith Residency, Moosarambagh, Malakpet, Hyderabad-500036&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Google Map"
          ></iframe>

          <p>Located in the heart of Hyderabad</p>
        </section>
      </div>
    </div>
  );
};

export default ContactUs;